const HIDE_SP_CSS = `
html.sp-message-open {
  position: static !important;
  overflow: visible !important;
}
div[id^="sp_message"],
iframe[id^="sp_message"] {
  display: none !important;
}
html.sp-message-open body {
  position: static !important;
  overflow: visible !important;
}
div[id^="sp_message"],
iframe[id^="sp_message"] {
  display: none !important;
}
`

export function injectHideSpCss() {
  const root = document.getElementById('root')
  if (!root) {
    console.warn('injectHideSpCss: no #root element found')
    return
  }
  const style = document.createElement('style')
  style.id = 'hide-sp-css'
  style.textContent = HIDE_SP_CSS
  root.appendChild(style)
}
